import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { useThrottleFn } from 'ahooks';
import { useEffect } from 'react';
import { noop } from '@src/utils/common-util';
import { pageSwiperEffect } from '@src/components/swiper/page-swiper/config';
import { computed, observable } from 'mobx';
class pageSwiperStore {
  /**
   * swiperOptions 默认的属性值
   * @type {{simulateTouch: boolean, observeParents: boolean, releaseOnEdges: boolean, effect: string, mousewheel: boolean, fadeEffect: {}, slidesPerView: number, observe: boolean, direction: string}}
   */
  swiperOptions = {
    direction: 'vertical',
    slidesPerView: 1,
    observe: true,
    observeParents: true,
    mousewheel: false,
    releaseOnEdges: true,
    simulateTouch: false,
    on: {
      slideChangeTransitionStart: () => {
        clearTimeout(this.finalPageTransitionEndTime);
        this.finalPageTransitionEnd = false;
      },
      slideChangeTransitionEnd: () => {
        this.finalPageTransitionEndTime = setTimeout(() => {
          this.finalPageTransitionEnd = this.baseSwiperStore.activeIndex >= this.baseSwiperStore.size - 1;
        }, 900);
      }
    }
  };

  finalPageTransitionEndTimer = null;
  onPageSwiperChange = noop;

  baseSwiperStore = new BaseSwiperStore({
    swiperOptions: this.swiperOptions
  });

  @observable onChangeFooterState = noop;
  // 是否允许页面上有弹窗开启的时候滚动
  allowScrollWhileModalOpen = false;
  // 是否可以切换
  allowSwitch = true;
  // 最后一页滑动结束
  @observable finalPageTransitionEnd = false;

  constructor({ effectMode = pageSwiperEffect.FADE, ...rest } = {}) {
    Object.assign(this, rest);
    this.baseSwiperStore.swiperOptions = { ...this.baseSwiperStore.swiperOptions, ...effectMode };
  }

  @computed
  get activeIndex() {
    return this.baseSwiperStore.activeIndex;
  }

  /**
   * 全屏滚动鼠标监听
   * 因为使用swiper自带的鼠标上线滚动会出现页面闪动的问题
   * 因此通过监听鼠标滚动事件来实现全屏滚动
   * @param ev
   */
  handleScroll = ev => {
    let isScrollUp;
    if (ev.wheelDelta) {
      isScrollUp = ev.wheelDelta > 0;
    } else {
      isScrollUp = ev.detail < 0;
    }

    const currentActiveIndex = this.baseSwiperStore.activeIndex;
    const nextActiveIndex = currentActiveIndex + (isScrollUp ? -1 : 1);
    /**
     * 禁止滚动到 -1 屏
     */
    if (nextActiveIndex < 0) {
      return;
    }

    /**
     * 获取总屏数
     */
    const totalSwiperSlides = this.baseSwiperStore.swiperRef.current.swiper.slides.length;
    /**
     * 其他溢出场景禁止
     */
    if (nextActiveIndex > totalSwiperSlides - 1) {
      return;
    }
    /**
     * 正常场景允许滚动
     */
    this.baseSwiperStore.onChange(nextActiveIndex);
  };

  /**
   * 是否有弹窗打开
   * @returns {boolean}
   */
  hasModalOpen = () => {
    return (
      document?.querySelectorAll('[class*=openModal][data-open=true]').length ||
      document?.querySelectorAll('[class*=PhotoView-Portal]').length ||
      document?.querySelectorAll('[class*=age-modal]').length ||
      // document?.querySelectorAll('[class*=innerExpanded_nav]').length ||
      // document?.querySelectorAll('[class*=innerExpanded_footer]').length ||
      document?.querySelectorAll('[data-name="languageExpand"][data-open="true"]').length
    );
  };

  use() {
    const { run: onScroll } = useThrottleFn(
      (...args) => {
        if (!this.allowSwitch) {
          return;
        }
        if (!this.allowScrollWhileModalOpen && this.hasModalOpen()) {
          return;
        }
        this.handleScroll(...args);
      },
      { wait: 1200, leading: true, trailing: false }
    );

    this.lastScrollTime = 0;
    useEffect(
      () => {
        const handleWheel = e => {
          const now = Date.now();
          const timeDiff = now - this.lastScrollTime;

          // 时间间隔小于50ms视为惯性滚动，直接阻止
          if (timeDiff <= 50) {
            return;
          }

          // 普通滚动正常处理
          this.lastScrollTime = now;
          onScroll(e);
        };

        document.addEventListener('wheel', handleWheel, { passive: false });
        return () => {
          document.removeEventListener('wheel', handleWheel);
        };
      },
      [onScroll]
    );
    useEffect(
      () => {
        this.onPageSwiperChange(this.baseSwiperStore.activeIndex, this.baseSwiperStore.swiperRef.current.swiper.slides.length);
      },
      [this.baseSwiperStore.activeIndex]
    );
  }
}

export default pageSwiperStore;
